import { gql } from "@apollo/client";

export const submitWebLens = gql`
    mutation submitWebLens($input: SubmitWebLensRequest!) {
        submitWebLens(input: $input) {
            lensId
            status
            validation {
                name
                passed
                detail
            }
        }
    }
`;
